import { ValueSetterParams } from 'ag-grid-community';

import { NUMBER_GREATER_THAN_ZERO } from 'app/global/variables';

import { LookupTypeEnum } from 'app/graphql/generated/graphqlApolloTypes';

export interface ScheduleData {
  scheduleName: string | null;
  month_1: number | null;
  month_2: number | null;
  month_3: number | null;
  month_4: number | null;
  month_5: number | null;
  month_6: number | null;
  month_7: number | null;
  month_8: number | null;
  month_9: number | null;
  month_10: number | null;
  month_11: number | null;
  month_12: number | null;
}

export const getScheduleList = (data): ScheduleData[] => {
  if (!data) {
    return [];
  }
  const parsedData = JSON.parse(data);

  const scheduleList = [];
  Object.entries(parsedData).forEach((schedule) => {
    const data = {};
    data['scheduleName'] = schedule[0];
    Object.entries(schedule[1]).forEach((monthData) => (data[monthData[0]] = monthData[1]));
    scheduleList.push(data);
  });
  return scheduleList;
};

// value of percentage at max can have 5 decimal point
export const percentageValueFormatter = (num: number) => Math.round(num * 100000) / 100000;

export const onFail = (params: ValueSetterParams, tableType: string) => () => {
  const data = params.data;
  const field = params.colDef.field;

  if (params.oldValue || params.oldValue === 0) {
    data[field] = params.oldValue;
  } else {
    data[field] = tableType === LookupTypeEnum.Seasonality ? '0' : '100';
  }
  return false;
};

export const onSuccess = (params: ValueSetterParams) => () => {
  const data = params.data;
  const field = params.colDef.field;
  data[field] = field !== 'scheduleName' ? percentageValueFormatter(params.newValue) : params.newValue;
  params.node.setData(data);
  return true;
};

export const scheduleNameValidator = (params: ValueSetterParams) => {
  const { api, newValue } = params;
  const scheduleNameList = [];
  api.forEachNode((node) => scheduleNameList.push(node.data.scheduleName));

  return !scheduleNameList.includes(newValue);
};

export const valueValidator = (params: ValueSetterParams) => {
  const { newValue } = params;
  const floatValue = parseFloat(newValue);
  if (isNaN(newValue)) return false;
  if (NUMBER_GREATER_THAN_ZERO.test(floatValue.toString())) return floatValue >= 0;
  return false;
};

export const syncValidator = (
  params: ValueSetterParams,
  validateFn: (params: ValueSetterParams) => boolean,
  onSuccess: () => void,
  onFail: () => void
) => {
  if (validateFn(params)) {
    onSuccess();
  } else {
    onFail();
  }
  return true;
};

export const syncValueSetter = (
  params: ValueSetterParams,
  validateFn: (params: ValueSetterParams) => boolean,
  tableType: string
) => {
  syncValidator(params, validateFn, onSuccess(params), onFail(params, tableType));
  return true;
};
